import { makeOracle } from 'apprise-core/authz'
import { adminUsers, editTenant, manageTenant, Tenant } from 'apprise-core/tenant'
import { UserPermissionModule } from 'apprise-frontend-iam/user/modules'
import { TaggedModule } from 'apprise-frontend-tags/tag/modules'
import { TenantIcon, tenantPlural, tenantSingular, tenantType } from './constants'
import { TenantPermissionBox } from './permissions'
import { useTenantStore } from './store'



export const useTenantPermissionModule = () => {

    const store = useTenantStore()

    const module: UserPermissionModule<Tenant> = {

        Icon: TenantIcon,
        type: tenantType,
        plural: tenantPlural,

        actions: [

            { ...manageTenant, shortName: "tenant.actions.manage_short", name: "tenant.actions.manage_name", description: "tenant.actions.manage_desc", icon: <TenantIcon /> },
            { ...editTenant, virtual: true, shortName: "tenant.actions.manage_edit_short", name: "tenant.actions.manage_edit_name", description: "tenant.actions.manage_edit_desc", width: 90, icon: <TenantIcon /> },
            { ...adminUsers, virtual: true, shortName: "tenant.actions.manage_user_short", name: "tenant.actions.manage_user_name", description: "tenant.actions.manage_user_desc", width: 90, icon: <TenantIcon /> }

        ],


        Box: (props) => {

            const resourceRange = store.all() // all tenants in scope.

            const target = makeOracle().given(props.edited)

            return <TenantPermissionBox wildcard={target.hasNoTenant()} preselectWildcard resourceRange={resourceRange}  {...props} />

        }
    }

    return module
}

export const useTenantTaggeModule = () => {

    const module: TaggedModule = {

        Icon: TenantIcon,
        type: tenantType,
        singular: tenantSingular,
        plural: tenantPlural
    }

    return module
}

